import React, { useState } from "react";
import PropTypes from "prop-types";
import DataTable from "react-data-table-component";
import { Dropdown } from "react-bootstrap";
import { Link, withRouter } from "react-router-dom";
import { withLabelsContext, withUserContext } from "context";
import * as config from "config";
import styled, { useTheme } from "styled-components";
import getTableStyles from "themes/table-styles";
import { Button, JustifyBetween, Toolbar, PageTitle, OverlayTooltip } from "components";
import Select from "components/Select/Select";
import ToggleButtonGroup from "../../../../components/ToggleButtonGroup/ToggleButtonGroup";
import * as util from "services/util";
import Loader from "components/Spinner/Loader";
import {
  IconAdministrativeTools,
  IconChatBubble,
  IconDownload,
  IconEditGraphReport,
  IconExam,
  IconMenuVertical,
  IconNoEdit,
  IconPassFail,
  IconAttendanceTracker,
} from "Icons";
import MediaQuery from "react-responsive";
// import { DefaultLegendContent } from "recharts/types/component/DefaultLegendContent";

const StyledTable = styled.div`
  .rdt_Table {
    overflow: unset;
    height:100%;
  }
  .rdt_TableHeadRow {
    border-radius: 10px 10px 0 0;
  }
  
  
`;

const StyledDropdownMenu = styled.div`
  width: 176px;
  padding-left: 10px;
  padding-right: 10px;
  color: #001b4a;
  text-align: initial;
  .dropdown-item {
    padding: 8px 5px;
    font-size: 12px;
    border-bottom: 1px dashed #979797;

    a {
      color: #001b4a;
    }

    svg {
      width: 16px;
      height: 16px;
      fill: #aeafad;
    }

    &:active,
    &:hover {
      background-color: #e9ecef;
      color: inherit;
    }

    &:last-child {
      border-bottom: none;
    }
  }
`;

const CustomDropdownToggle = React.forwardRef(({ children, onClick }, ref) => (
  <span 
    ref={ref}
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
  >
    {children}
  </span>
));

const DropdownMenu = (props) => {

  const wrapText = (name,maxLength) => {
    const wrappedText=name.length > maxLength ? name.slice(0, maxLength)+ '...' : name;
    return(
      wrappedText
    )
  }

  const dropdownList = [
    {
      name: wrapText(`${props.ctx_labels.plural.assessment} ${props.ctx_labels.singular.result}`,12),
      tip:`${props.ctx_labels.plural.assessment} ${props.ctx_labels.singular.result}`,
      path: config.ROUTES.assessmentList,
      icon: <IconExam className="mr-2 ml-0" />,
      screenId: config.memberSubmenuE.ASSESSMENT_LIST,
    },
    {
      name: wrapText(`${props.ctx_labels.singular.chapter} ${props.ctx_labels.singular.allocation}`,18),
      tip:  `${props.ctx_labels.singular.chapter} ${props.ctx_labels.singular.allocation}`,
      path: config.ROUTES.chapterallocation,
      icon: <IconAdministrativeTools className="mr-2 ml-0" />,
    },
    {
      name: wrapText(`${props.ctx_labels.singular.class} ${props.ctx_labels.singular.list}`,10),
      tip: `${props.ctx_labels.singular.class} ${props.ctx_labels.singular.list}`,
      path: config.ROUTES.courseClassList,
      icon: <IconPassFail className="mr-2 ml-0" />,
    },
    {
      name: wrapText(`${props.ctx_labels.singular.publish} ${props.ctx_labels.plural.assessment}`,15),
      tip: `${props.ctx_labels.singular.publish} ${props.ctx_labels.plural.assessment}`,
      path: config.ROUTES.createTest,
      icon: <IconNoEdit className="mr-2 ml-0" />,
      screenId: config.memberSubmenuE.TEST,
    },
    {
      name: wrapText(`${props.ctx_labels.singular.sendMessages}`,13),
      tip: `${props.ctx_labels.singular.sendMessages}`,
      path: config.ROUTES.chat,
      icon: <IconChatBubble className="mr-2 ml-0" />,
      // screenId: config.memberSubmenuE.MESSAGES,
    },
    {
      name: wrapText(`${props.ctx_labels.singular.curriculum} ${props.ctx_labels.singular.progress}`,16),
      tip: `${props.ctx_labels.singular.curriculum} ${props.ctx_labels.singular.progress}`,
      path: config.ROUTES.subjectProgress,
      icon: <IconEditGraphReport className="mr-2 ml-0" />,
    },
    
    // {
    //   name: "Q/A",
    //   path: "#",
    //   icon: <IconQuestions className="mr-2 ml-0" />,
    // },
    {
      name: wrapText(`${props.ctx_labels.singular.addAttendance}`,14),
      tip: `${props.ctx_labels.singular.addAttendance}`,
      path: config.ROUTES.addAttendance,
      icon: <IconAttendanceTracker className="mr-2 ml-0" />,
    },
  ];
 

  const dropdownList1 = [
    {
      name: wrapText(`${props.ctx_labels.plural.assessment} ${props.ctx_labels.singular.result}`,18),
      tip: `${props.ctx_labels.plural.assessment} ${props.ctx_labels.singular.result}`,
      path: config.ROUTES.assessmentList,
      icon: <IconExam className="mr-2 ml-0" />,
      screenId: config.memberSubmenuE.ASSESSMENT_LIST,
    },
    {
      name: wrapText(`${props.ctx_labels.singular.class} ${props.ctx_labels.singular.list}`,10),
      tip: `${props.ctx_labels.singular.class} ${props.ctx_labels.singular.list}`,
      path: config.ROUTES.courseClassList,
      icon: <IconPassFail className="mr-2 ml-0" />,
    },
    {
      name: wrapText(`${props.ctx_labels.singular.sendMessages}`,13),
      tip: `${props.ctx_labels.singular.sendMessages}`,
      path: config.ROUTES.chat,
      icon: <IconChatBubble className="mr-2 ml-0" />,
      // screenId: config.memberSubmenuE.MESSAGES,
    },
    {
      name: wrapText(`${props.ctx_labels.singular.curriculum} ${props.ctx_labels.singular.progress}`,16),
      tip: `${props.ctx_labels.singular.curriculum} ${props.ctx_labels.singular.progress}`,
      path: config.ROUTES.subjectProgress,
      icon: <IconEditGraphReport className="mr-2 ml-0" />,
    },
    
  ];

  const displayChapter = props.rowData.display_chapter;
  
  const dropDownListDisplay = displayChapter
    ? dropdownList
    : dropdownList.filter(
        (type) => type.name != `${props.ctx_labels.singular.chapter} ${props.ctx_labels.singular.allocation}`
      );

  // const displayChapter = props.rowData.display_chapter;
  // const displayChapter = dropdownList

  // const dropDownListDisplay = displayChapter;
    // ? dropdownList
    // : dropdownList.filter(
    //     (type) => type.name != `${props.ctx_labels.singular.chapter} Allocation`
    //   );
  return (
    <Dropdown drop="right">
      <Dropdown.Toggle as={CustomDropdownToggle} id="dropdown-basic">
        <Button iconOnly variant="white" size="sm" pill className="px-2">
          <IconMenuVertical />
        </Button>
      </Dropdown.Toggle>

      {props.rowData.expired === 0 ?
      <Dropdown.Menu>
        <StyledDropdownMenu>      
          {dropDownListDisplay.map((dropdown, i) => {
            return (
              <Dropdown.Item>
                <Link
                  to={{ pathname: dropdown.path, data: props.rowData, fromClassViewer: props.fromClassViewer, isClass: props.isClass, addRedirection: props.addRedirection,}}
                  key={i}
                  onClick={() =>
                    dropdown.screenId &&
                    props.onMenuChange(dropdown.screenId, "update")
                  }
                >
                  <OverlayTooltip
                    placement="top"
                    tip={dropdown.tip}
                  >
                    <span>
                      {dropdown.icon}
                      {dropdown.name}
                    </span>
                  </OverlayTooltip>
                  {/* <IconPassFail className="mr-2 ml-0" /> */}
                </Link>
              </Dropdown.Item>
            );
          })}
        </StyledDropdownMenu>
        </Dropdown.Menu>
      :
      <Dropdown.Menu>
      <StyledDropdownMenu>
      {dropdownList1.map((dropdown, i) => {
        return (
          <Dropdown.Item>
            <Link
              to={{ pathname: dropdown.path, data: props.rowData , isClass: props.isClass}}
              key={i}
              onClick={() =>
                dropdown.screenId &&
                props.onMenuChange(dropdown.screenId, "update")
              }
            >
              {dropdown.icon}
              {dropdown.name} 

              {/* <IconPassFail className="mr-2 ml-0" /> */}
            </Link>
          </Dropdown.Item>
        );
      })}
    </StyledDropdownMenu>
    </Dropdown.Menu>
         } 
    </Dropdown>
  );
};

function TableSubjects(props) {
  const [filterText, setFilterText] = useState("");
  const [expireDate, setexpireDate] = useState(0);
  const extendOptions = [
    { label: props.ctx_labels.singular.expired, value: "1" },
    { label: props.ctx_labels.singular.open, value: "0" },
  ];
  const handleChange = (e) => {
    props.expiredCourses(e);
    setexpireDate(e)
  }

  let filteredItems =
    props.data !== ""
      ? props.data.filter((item) => item.expired == expireDate )
      : props.data;
   
     filteredItems = filterText !== "" 
      ? filteredItems.filter((item) =>{
        return String(item.class_id) === filterText})
        :filteredItems;

const theme = useTheme();
  const tableStyles = getTableStyles(theme);

  const columns = [
    // {
    //   name: `${props.ctx_labels.singular.curriculum}`,
    //   selector: "coursepub_name",
    //   sortable: true,
    //   wrap: true,
    //   width: "220px",
    // },
    {
      name: `${props.ctx_labels.singular.course}`,
      selector: row => row.coursepub_name,
      sortable: false,
      width: "200px",
      wrap: false,
      cell: (e) => {
        return (
          <OverlayTooltip placement="top" tip={e.coursepub_name}>
            <span style={{ display: "block", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
              {e.coursepub_name}
            </span>
          </OverlayTooltip>
        );
      },
    },
    {
      name: props.ctx_labels.singular.variant,
      selector: row => row.coursename,
      width: "175px",
    },
    {
      name: `${props.ctx_labels.singular.class}`,
      selector: row => row.classname,
      sortable: true,
      width: "85px",
      cell: (e) => {
        return (
          <OverlayTooltip placement="top" tip={e.classname}>
            <span style={{ display: "block", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
              {e.classname}
            </span>
          </OverlayTooltip>
        );
      },
    },
    {
      name: `${props.ctx_labels.singular.curriculum}`,
      selector: row => row.currname,
      sortable: true,
      wrap: true,
      width: "110px",
    },
    {
      name: `${props.ctx_labels.singular.startDate}`,
      selector: row => row.publishedFrom,
      sortable: true,
      sortFunction: (a, b) => {
        return util.searchSorting(a.publishedFrom, b.publishedFrom)
      },

    },
    {
      name: `${props.ctx_labels.singular.endDate}`,
      selector: row => row.publishedTo,
      sortable: true,
      sortFunction: (a, b) => {
        return util.searchSorting(a.publishedTo, b.publishedTo)
      },

    },
    {
      name: `${props.ctx_labels.plural.trainee}`,
      selector: row => row.trainees,
      sortable: true,
      width: "100px"
    },
    {
      name: props.ctx_labels.singular.complperc,
      selector: row => row.percentage_completion,
      sortable: true,
      width: "100px",
    },
    {
      name: ` ${props.ctx_labels.singular.avgTest} (%)`,
      selector: row => row.avg_test_percentage,
      sortable: true,
      width: "100px",
    },
    {
      name: "",
      selector: row => row.actions,
      sortable: false,
      allowOverflow: true,
      ignoreRowClick: true,
      button: true,

      cell: (rowData) => (
        <>
          {props.ctx_user.user.reportsTrainer &&
            <Button
              iconOnly
              variant="white"
              size="sm"
              pill
              className="px-2 mr-3 ml-0"
              onClick={(e) => props.onDownloadClick(e, rowData)}
            >
              <IconDownload />
            </Button>
          }
          <DropdownMenu rowData={rowData} {...props} fromClassViewer />
        </>
      ),
    },
  ];

  return (
    <>
      {/* -----------subjects table----------  */}
      <MediaQuery maxDeviceWidth={767}>
        <div className="filter-style">
          <div><PageTitle>{`${props.ctx_labels.singular.my} ${props.ctx_labels.plural.course}`}</PageTitle></div>
          {/* <div className="text-color4">{filteredItems.length} results found</div> */}
          {/* <div className="text-color4"></div> */}
          <div>
            {
            // 0 < props.data.length &&
              <div style={{ marginLeft: "auto", marginBottom: "10px" }}>
                <ToggleButtonGroup
                  options={extendOptions}
                  className="toggle-column-date"
                  onChange={handleChange}
                  value={expireDate
                    ? expireDate
                    : "0"}
                />
              </div>
            }

            {0 < props.data.length &&
              <Toolbar>
                <Toolbar.Item style={{ marginLeft: "auto",marginBottom: "10px" }}>
                  <Select
                    isSearchable={true}
                    value={filterText}
                    onChange={(e) => {
                      setFilterText(e);
                      props.filterChange(e);
                    }}
                    required={false}
                    // onClear={handleClear}
                    unselectedValue=""
                    placeholder={props.ctx_labels.singular.filter}
                    options={props.ctx_user.user.memberClasses}
                    style={{ marginRight: "160px" }}
                  />
                </Toolbar.Item>
              </Toolbar>
            }
          </div>
          
          {/* Help text for mobile users */}
          {/* {filteredItems.length > 0 && (
            <div style={{ 
              marginBottom: "15px", 
              padding: "10px 15px", 
              backgroundColor: "#e3f2fd", 
              borderRadius: "6px",
              border: "1px solid #bbdefb",
              fontSize: "14px",
              color: "#1976d2"
            }}>
              💡 <strong>Tip:</strong> Tap on any course row to view detailed information and analytics.
            </div>
          )} */}
        </div>
      </MediaQuery>
      <MediaQuery minDeviceWidth={768}>
      <JustifyBetween className="align-items-center">
        <PageTitle>{`${props.ctx_labels.singular.my} ${props.ctx_labels.plural.course}`}</PageTitle>
        {/* <div className="text-color4">{filteredItems.length} results found</div> */}
        {/* <div className="text-color4"></div> */}
        {
        // 0 < props.data.length  &&
        <div style={{marginLeft:"auto",marginBottom:"10px" }}>
        <ToggleButtonGroup
          options={extendOptions}
          className="toggle-column-date"
          onChange={handleChange}
          value = {expireDate
                     ? expireDate
                    :"0"}
        />
        </div>
          }        

        {0 < props.data.length  &&
        <Toolbar>
          <Toolbar.Item style={{ minWidth: "130px", marginLeft:"8px", marginBottom:"10px" }}>
            <Select
              isSearchable={true}
              value={filterText}
              onChange={(e) =>{
                setFilterText(e);
                props.filterChange(e);
              } }
              required={false}
              // onClear={handleClear}
              unselectedValue=""
              placeholder={props.ctx_labels.singular.filter}
              options={props.ctx_user.user.memberClasses}
              style = {{ marginRight: "160px"}}
            />
          </Toolbar.Item>
        </Toolbar>
}
      </JustifyBetween>
      </MediaQuery>

      <MediaQuery minDeviceWidth={768}>
      <StyledTable>
        <DataTable
          noHeader={true}
          columns={columns}
          data={filteredItems}
          customStyles={tableStyles}
          pagination
          paginationPerPage={5}
          paginationServer
          paginationTotalRows={props.totalCount}
          onChangePage={props.onPageChange}
          paginationComponentOptions={{
            noRowsPerPage: true,
          }}
          striped
          overflowY={true}
          //overflowYOffset="400px"
          style={{ overflow: "visible" }}
          responsive={false}
          className=""
          defaultSortField="no"
          progressPending={props.searching}
          progressComponent={<Loader active className="entity-loader" />}
          persistTableHead
          onRowClicked={(rowData) => {
            try {
              // Navigate to Mycourse with course data
              props.history.push({
                pathname: config.ROUTES.MyCourseDetails,
                state: { 
                  courseData: rowData,
                  fromMyClasses: true
                }
              });
            } catch (error) {
              console.error('Navigation failed:', error);
              // Fallback: try to navigate without state
              props.history.push(config.ROUTES.MyCourseDetails);
            }
          }}
          pointerOnHover={true}
        />
      </StyledTable>
      </MediaQuery>
      <MediaQuery maxDeviceWidth={767}>
      <StyledTable>
        <DataTable
          noHeader={true}
          columns={columns}
          data={filteredItems}
          customStyles={tableStyles}
          pagination
          paginationPerPage={5}
          paginationServer
          paginationTotalRows={props.totalCount}
          onChangePage={props.onPageChange}
          paginationComponentOptions={{
            noRowsPerPage: true,
          }}
          striped
          overflowY={true}
          //overflowYOffset="400px"
          style={{ overflow: "visible" }}
          responsive={true}
          className=""
          defaultSortField="no"
          progressPending={props.searching}
          progressComponent={<Loader active className="entity-loader" />}
          persistTableHead
          onRowClicked={(rowData) => {
            try {
              // Navigate to Mycourse with course data
              props.history.push({
                pathname: config.ROUTES.MyCourseDetails,
                state: { 
                  courseData: rowData,
                  fromMyClasses: true
                }
              });
            } catch (error) {
              console.error('Navigation failed:', error);
              // Fallback: try to navigate without state
              props.history.push(config.ROUTES.MyCourseDetails);
            }
          }}
          pointerOnHover={true}
        />
      </StyledTable>
      </MediaQuery>
      
    </>
  );
}

TableSubjects.propTypes = {
  data: PropTypes.object,
};

TableSubjects.defaultProps = {
  data: [],
};

export default withLabelsContext(withUserContext(withRouter(TableSubjects)));
